var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"process"},[_c('div',{staticClass:"process_content"},_vm._l((_vm.processList),function(item,index){return _c('div',{key:index,staticClass:"process_item"},[_c('div',{staticClass:"img_item"},[_c('img',{attrs:{"src":_vm.imgs[index],"alt":""}})]),_c('div',{staticClass:"step_word"},[_vm._v(_vm._s(item))])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }